// home.js
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Fetch from '../../../../../core/util/core/Fetch';
import config from '../../../../config/config';
import CustomList from '../Util/List/CustomList/CustomList'
import CustomListContainer from '../Util/List/CustomList/CustomListContainer'
import { loadData } from '../Util/List/CustomList/loadData';

import '../home/Home.css';

function General(props) {
  const sessionSelector = useSelector((state) => { return state.core.session });
  const friendly_url = sessionSelector.pdc_project_friendly_url;

  const [listContent, setListContent] = useState([])

  useEffect(() => {
    const load = async () => {
      let options = {};
      options.types = [];
      let getTypes = await Fetch.post(`${config.endpoints.backend}portal/getalldemonstrativetypesbyproject`, {friendly_url});
      if (getTypes.length > 0) {
        getTypes.map((type) => {
          options.types.push({
            label: type.name,
            value: type.id
          })
        })
      }

      const list = await getList(options);
      setListContent(
        <CustomListContainer
          canAdd={false}
          labelTitle={list.listGeneral.labelTitle}
          icon={list.listGeneral.icon}
          content={<CustomList list={{ ...list.listGeneral, ...list.pathsGeneral }} />}
        />
      )
    }
    load();
  }, [])


  const getList = async (options) => {
    const filters = {
      validateOnChange: true,
      showGoBackButton: false,
      showSubmitButton: false,
      handleSubmit: loadData,
      fields: [
        {
          name: 'pdc_demonstrative_type_id',
          type: 'select',
          options: options.types,
          label: 'Tipo',
          validations: {
            required: false
          },
          columnSize: 3
        },
        {
          name: 'year',
          type: 'year',
          label: 'Ano',
          selectable: true,
          validations: {
            required: false
          },
          columnSize: 3
        },
        {
          name: 'filtro',
          type: 'submit',
          label: 'Pesquisar',
          columnSize: 1
        },
        {
          name: 'reset',
          type: 'reset',
          label: 'Limpar',
          columnSize: 2
        }
      ],
    }

    const pathsGeneral = {
      endpoint: config.endpoints.backend + 'portal/getalldemonstratives'
    }
    const listGeneral = {
      labelTitle: 'Relatórios',
      icon: 'fa-newspaper',
      formFilters: filters,
      filter: {
        friendly_url,
        orderPeriod: true
      },
      canDownload: true,
      fieldToDownload: 'file',
      columns: [
        {
          name: 'demonstrative_type',
          label: 'Tipo de Demonstrativo'
        },
        {
          name: 'demonstrative_period',
          label: 'Período de Demonstrativo'
        },
        {
          name: 'reference',
          label: 'Referência'
        },
        {
          name: 'obs',
          label: 'Descrição'
        }
      ]
    };

    return {
      filters,
      listGeneral,
      pathsGeneral
    }
  }

  return (
    <div>
      {listContent}
    </div>
  );
};

export default General;
